import React from 'react';
import dayjs from 'dayjs';
import './index.scss';
import { t } from 'i18next';
import { customRound, moneyFormatter } from 'utli';

function DepositInvoiceDetailContent({ data }) {
  return (
    <>
      <div>
        <h1 className='text-center'>{data?.invoice_number}</h1>
        <div className='d-flex mb-2' style={{ columnGap: '125px' }}>
          <h4>
            {t('address_book.code')}: {data?.address_code}
          </h4>
          <h4>
            {t('waybill_entry.sale_person')}: {data?.sale_person?.name}
          </h4>
        </div>
      </div>
      <div className='mt-4'>
        <div
          className='info-item'
          style={{
            // borderBottom: '1px solid rgb(108 108 138)',
            paddingBottom: 5,
          }}
        >
          <h4 style={{ width: '50%' }}>
            {t('address_book.sender')} {t('information')}
          </h4>
          <h4>
            {' '}
            {t('address_book.receiver')} {t('information')}
          </h4>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {/* {t('waybill_entry.company')} : */}
            {data?.sender?.company}
          </span>
          <span>
            {' '}
            {/* {t('waybill_entry.company')} : */}
            {data?.receiver?.company}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }} className='mb-1'>
            {/* {t('address_book.sender')} :  */}
            {data?.sender?.name}
          </span>
          <span>
            {/* {t('address_book.receiver')}:  */}
            {data?.receiver?.name}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }} className='mb-1'>
            {/* {t('waybill_entry.phone')} :  */}
            {data?.sender?.phone}
          </span>
          <span>
            {/* {t('waybill_entry.phone')} :  */}
            {data?.receiver?.phone}
          </span>
        </div>

        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {/* {t('waybill_entry.address')} :  */}
            {data?.sender?.address}
          </span>
          <span>
            {/* {t('waybill_entry.address')} :  */}
            {data?.receiver?.address}
          </span>
        </div>
      </div>
      <div className='mt-3'>
        <div
          className='info-item'
          style={{
            paddingBottom: 5,
          }}
        >
          <h4 style={{ width: '50%' }}>{t('waybill_entry.basic_information')}</h4>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {t('deposit_invoice.invoice_number')}: {data?.invoice_number}
          </span>
          <span>
            {t('deposit_invoice.quotation_no')}: {data?.quotation_no || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            DIL No: {data?.dil_no || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {t('deposit_invoice.invoice_date')}: {data?.invoice_date ? dayjs(data.invoice_date).format('DD/MM/YYYY') : '-'}
          </span>
          <span>
            {t('waybill_entry.paymentType')}: {data?.paymentType?.name || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            Currency: {data?.currency}
          </span>
        </div>
      </div>
      <div className='mt-3'>
        <div
          className='info-item'
          style={{
            borderBottom: '1px solid rgb(108 108 138)',
            paddingBottom: 5,
          }}
        >
          <h4 style={{ width: '100%' }}>{t('deposit_invoice.item_information')}</h4>
        </div>
        
        {/* Items Table Header */}
        <div className='info-item' style={{ fontWeight: 'bold', borderBottom: '1px solid #ddd', paddingBottom: 5, paddingTop: 10 }}>
          <span style={{ width: '25%' }}>{t('deposit_invoice.item_name')}</span>
          <span style={{ width: '15%' }}>{t('deposit_invoice.unit')}</span>
          <span style={{ width: '15%' }}>{t('waybill_entry.qty')}</span>
          <span style={{ width: '20%' }}>{t('deposit_invoice.amount')}</span>
          <span style={{ width: '25%' }}>{t('deposit_invoice.remark')}</span>
        </div>

        {/* Items Rows */}
        {data?.items && data.items.length > 0 ? (
          data.items.map((item, index) => (
            <div key={index} className='info-item' style={{ paddingTop: 8, paddingBottom: 8, borderBottom: '1px solid #f0f0f0' }}>
              <span style={{ width: '25%' }}>{item?.itemname || '-'}</span>
              <span style={{ width: '15%' }}>{item?.unit || '-'}</span>
              <span style={{ width: '15%' }}>{item?.qty || '-'}</span>
              <span style={{ width: '20%' }}>{item?.amount ? moneyFormatter(item.amount) : '-'}</span>
              <span style={{ width: '25%' }}>{item?.remark || '-'}</span>
            </div>
          ))
        ) : (
          <div className='info-item' style={{ paddingTop: 10 }}>
            <span>{t('nodata')}</span>
          </div>
        )}

        {/* Total Amount */}
        <div className='d-flex justify-content-end' style={{ paddingRight: '50px', paddingTop: '20px' }}>
          <h3>
            {t('waybill_entry.total_amount')}: &nbsp;{' '}
            {data?.total_amount ? moneyFormatter(customRound(data.total_amount.toFixed(2))) : '0.00'}
          </h3>
        </div>
      </div>
    </>
  );
}
export default DepositInvoiceDetailContent;
